module.exports = __webpack_public_path__ + "img/sulidores2.43308536.png";